import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { config } from "vuex-module-decorators";
config.rawError = true;

Vue.use(Vuex);

const getModules = (group = [], result = {}) => {
  group.forEach(item => {
    // let key = item.replace(/(^\.\/)|(\.ts)/g, "");
    // 扩展子文件夹的模块文件。
    let key = item.replace(/(^\.\/([\s\S]+\/)?)|(\.ts)/g, "");
    result[key] = file(item).default || file(item);
  });
  return result;
};
const file = require.context("./modules", true, /\.ts$/);
const modules = getModules(file.keys());

export interface RootState {}

export default new Vuex.Store<RootState>({
  state: {},
  modules,
  plugins: [
    // vuex 缓存
    createPersistedState({
      key: "win-together-h5",
      storage: window.localStorage // 购物车跟APP有交互，用localStorage
    })
  ]
});
